// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightOutlinedSvg from "@ant-design/icons-svg/es/asn/RightOutlined";
import AntdIcon from '../components/AntdIcon';

var RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightOutlinedSvg
  }));
};

RightOutlined.displayName = 'RightOutlined';
export default /*#__PURE__*/React.forwardRef(RightOutlined);